import styled, { css, TColorProp } from 'styled-components';

import { getThemeColor } from '~/common/utils/get-theme-color';
import { SPACING } from '~/common/layout-propertis/spacing';
import { RADIUS } from '~/common/layout-propertis/radius';

export const CheckOptionContainer = styled.li<{
  selected: boolean;
  disabled: boolean;
  background: TColorProp;
  hoverColor: TColorProp;
  selectedBorderColor: TColorProp;
}>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: ${SPACING._8};
  border-radius: ${RADIUS._10};
  background-color: ${({ theme, background }) =>
    getThemeColor(theme, background)};
  border: 1px solid ${({ theme }) => theme.neutral[700]};
  transition: 200ms;
  cursor: pointer;

  ${({ selected, selectedBorderColor, theme }) =>
    selected &&
    css`
      border-color: ${getThemeColor(theme, selectedBorderColor)};
    `}

  &:hover {
    background-color: ${({ theme, hoverColor }) =>
      getThemeColor(theme, hoverColor)};
    ${({ selected }) =>
      !selected &&
      css`
        border-color: ${({ theme }) => theme.neutral[0]};
      `}
  }

  ${({ disabled, theme }) =>
    disabled &&
    css`
      border-color: ${theme.neutral[900]};
      pointer-events: none;
    `};
`;
